import jQuery from 'jquery'

jQuery(function ($) {
  const $cftForm = $('.wpcf7-form')
  const $inputs = $cftForm.find('input:visible, textarea:visible')

  $inputs.on('focus', (ev) => {
    const $el = $(ev.currentTarget)
    $el.parent().addClass('is_active')
  })

  $inputs.on('blur', (ev) => {
    const $el = $(ev.currentTarget)
    if (!$el.val()) {
      $el.parent().removeClass('is_active')
    }
  })

  // [...textareas, ...inputs].forEach((input) => {
  //   const parent = input.parentNode
  //   const grandpa = parent.parentNode
  //   if (isRequired(input)) {
  //     const target = grandpa.classList.contains('textarea') ? grandpa : parent
  //     target.classList.add('is-required')
  //   }

  //   input.addEventListener('focus', () => {
  //     parent.classList.add('active')
  //   })

  //   input.addEventListener('blur', () => {
  //     parent.classList[input.value === '' ? 'remove' : 'add']('active')
  //   })

  //   input.addEventListener('input', () => {
  //     if (isRequired(input)) {
  //       input.classList[input.value === '' ? 'add' : 'remove']('is-red')
  //       input.classList[input.value === '' ? 'remove' : 'add']('is-green')
  //     } else {
  //       input.classList[input.value === '' ? 'add' : 'remove']('is-salmon')
  //       input.classList[input.value === '' ? 'remove' : 'add']('is-green')
  //     }
  //   })
  // })
})
